"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=news-item.js.map